var baseValues=require("./_baseValues"),keys=require("./keys");function values(e){return null==e?[]:baseValues(e,keys(e))}module.exports=values;